const mapStateToThis = ({ config, session }) => {
  const { homePageLink } = config;
  const { locale } = session;

  return {
    homePageLink,
    locale,
  };
};

const mapDispatchToThis = {};

@Inject('$ngRedux')
export class RwHomepageLinksController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-homepage-links/rw-homepage-links-controller.js